export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getConfig: function getConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.log(data);
      return request({
        url: "/admin/config/get",
        method: "get",
        params: data
      });
    },
    updateConfig: function updateConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/config/update",
        method: "post",
        data: data
      });
    }
  };
});